import React from "react";
import Navbar from "../components/Navbar";

const Help = () => {
  document.body.style = "background-color: #FAFCFE";
  return (
    <>
      <header>
        <Navbar userName={"Jack"} />
      </header>
      <main className="main">
        <h1>Help - WIP</h1>
      </main>
    </>
  );
};

export default Help;
